import React from "react";
import RadioSelect from "../../../FormElements/RadioSelect/RadioSelect";
import RadioGroup from "@material-ui/core/RadioGroup";
import Grid from "@material-ui/core/Grid";

function Controls(props) {
  const { configuration, createItem, setNextEnabled } = props;

  function handleChange(event, value) {
    setNextEnabled(true);
    createItem({ id: "controls", value: value });
  }

  return (
    <RadioGroup
      aria-label="Controls"
      name="controls"
      onChange={handleChange}
      defaultValue={configuration["controls"] ? configuration["controls"] : ""}
    >
      <Grid container spacing={3}>
        <Grid item sm={4} xs={6}>
          <RadioSelect value="10V" label="0-10V Dimming" />
        </Grid>
        {configuration.voltage === "Blank" &&
        (parseInt(configuration.length) > 2 ||
          (configuration.configurations != "Blank" &&
            configuration.configurations != "C")) ? (
          <Grid item sm={4} xs={6}>
            <RadioSelect value="DAL" label="DALI" />
          </Grid>
        ) : (
          <Grid item sm={4} xs={6}>
            <RadioSelect disabled={true} value="DAL" label="DALI" />
          </Grid>
        )}
        <Grid item sm={4} xs={6}>
          <RadioSelect value="LDE5" label="Lutron ECO" />
        </Grid>
        {parseInt(configuration.length) > 2 ||
        (configuration.configurations != "Blank") ? (
          <Grid item sm={4} xs={6}>
            <RadioSelect value="VDO" label="Lutron Vive" />
          </Grid>
        ) : (
          <Grid item sm={4} xs={6}>
            <RadioSelect value="VDO" disabled={true} label="Lutron Vive" />
          </Grid>
        )}
        {parseInt(configuration.length) > 2 ||
        (configuration.configurations != "Blank") ? (
          <Grid item sm={4} xs={6}>
            <RadioSelect value="CMA" label="Smartcast" />
          </Grid>
        ) : (
          <Grid item sm={4} xs={6}>
            <RadioSelect value="CMA" disabled={true} label="Smartcast" />
          </Grid>
        )}
      </Grid>
    </RadioGroup>
  );
}

export default Controls;
